import { __awaiter } from "tslib";
import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { getDefaultHeaders, useAcquireToken, useAppConfig, useAuth, } from '@msrceng/auth';
import { useQuery } from '@tanstack/react-query';
import { SLOW_DATA_STALE_TIME_MSEC } from '../../../constants';
import { QUERY_KEY_MY_SETTINGS } from './constants';
import { gqlrequest } from '../../graphql';
import { mySettingsGql } from '../../graphql/authzgql';
/**
 * React-query `useQuery` hook to get the user's preference settings.
 */
export const useMySettingsApi = () => {
    const { apiRoot } = useAppConfig();
    const { isApiTokenLoaded } = useAuth();
    const { inProgress } = useMsal();
    const acquireTokenSilent = useAcquireToken();
    return useQuery([QUERY_KEY_MY_SETTINGS], () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const token = (inProgress !== InteractionStatus.Startup &&
            ((_a = (yield acquireTokenSilent())) === null || _a === void 0 ? void 0 : _a.accessToken)) ||
            undefined;
        const defaultHeaders = getDefaultHeaders(token);
        return yield gqlrequest(apiRoot + '/authzgraphql', mySettingsGql, defaultHeaders).then(data => data.authz_mySettings);
    }), {
        retry: false,
        keepPreviousData: true,
        cacheTime: SLOW_DATA_STALE_TIME_MSEC,
        staleTime: SLOW_DATA_STALE_TIME_MSEC,
        refetchOnWindowFocus: false,
        enabled: isApiTokenLoaded,
    });
};
